import { render } from "./recruitStatistics.vue?vue&type=template&id=88637bf2&scoped=true"
import script from "./recruitStatistics.vue?vue&type=script&lang=js"
export * from "./recruitStatistics.vue?vue&type=script&lang=js"

import "./recruitStatistics.vue?vue&type=style&index=0&id=88637bf2&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88637bf2"]])

export default __exports__